import { render, staticRenderFns } from "./editPerson.vue?vue&type=template&id=17a1b8b6&"
import script from "./editPerson.js?vue&type=script&lang=js&"
export * from "./editPerson.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports